import { Box, Tooltip } from "@mui/material";
import { PropsWithChildren } from "react";
import { Property } from "types";

export function TooltipFormControl({ property, children }: { property: Property } & PropsWithChildren) {
    return <Tooltip
        title={property.tooltip || ''}
        key={`${property.name} (${property.type})`}
        placement="top"
        arrow>
        <Box width="100%">
            {children}
        </Box>
    </Tooltip>
}

